import { useContext, useEffect, useRef } from "react"
// import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import { donEnc } from "donation-encourager"
import "./donation-encourager.scss"
import { LangContext } from "gatsby-source-dek-wp"

export const ART_BODY_CLASS = "article-body-inner"

const DON_ENC_SETTINGS = {
  targetSelector: `.${ART_BODY_CLASS}:not(.no-donation-encourager)`,
  crossStorageUrl:
    "https://www.dekoder.org/d/cross-storage-hub/cross-storage-hub.html",
  domObserverEnabled: true,
  twingleWidgetUrl:
    "https://spenden.twingle.de/dekoder-ggmbh/donation-encourager/tw5dcbf7742aac7/widget",
  /* paypalId: "mail@dekoder.org",
  paypalReturnUrl: function () {
    // var vc = donEncVC()
    return window.location.href + "?utm-source=paypal-donation" // -" + vc
  }, */
  excludeSelector: "hr, h6, aside, span, script, .nav-bar, .ph-social-bar",
  strings: {
    credit: "",
    body: function (timeStr, contentsStr, amountStr, storage) {
      return storage.totalContents
        ? "Du hast bislang <strong>"
            .concat(contentsStr, "</strong> auf dekoder gelesen.* Was ")
            .concat(
              storage.totalContents === 1
                ? storage.readContents.gnose === 1
                  ? "ist sie"
                  : "ist er"
                : "sind sie",
              " dir wert? Vielleicht <strong>",
            )
            .concat(amountStr, "</strong>?")
        : ""
    },
    monthly: `Monatlich spenden und Klubmitglied werden?`,
    paypalMonthlyName: "Klubmitgliedschaft (monatlich)",
  },
  hooks: {
    onResetBtnClick: function () {
      /* trackCustomEvent({
        category: "donEnc",
        action: "donEnc__reset",
        nonInteraction: true,
      }) */
    },
    onUnlockBtnClick: function () {
      /* trackCustomEvent({
        category: "donEnc",
        action: "donEnc__unlock",
        nonInteraction: true,
      }) */
    },
    onCtaBtnClick: function () {
      /* trackCustomEvent({
        category: "donEnc",
        action: "donEnc__cta",
        nonInteraction: true,
      }) */
    },
    onDonationFinished: function () {
      /* trackCustomEvent({
        category: "donEnc",
        action: "donEnc__donationFinished",
        nonInteraction: true,
      }) */
    },
  },
  itemSelectorSettings: {
    items: [
      { value: 3, icon: "☕️" },
      { value: 5, icon: "🍕" },
      { value: 7, icon: "🌹" },
      { value: 50, icon: "💰" },
    ],
  },
  intrusivenessLevels: [
    {
      // level 1
      contentThreshold: 0,
      boxSettings: [{ position: "bottom", expanded: true }],
      itemSelectorSettings: {
        preselectedItemsFilter: (item, i) => i === 0,
      },
    },
    {
      // level 2
      contentThreshold: 5,
      boxSettings: [
        // { position: "middle", expanded: false },
        { position: "bottom", expanded: true },
      ],
      itemSelectorSettings: {
        preselectedItemsFilter: (item, i) => i === 1,
      },
    },
    {
      // level 3
      contentThreshold: 10,
      boxSettings: [
        // { position: "middle", expanded: false },
        { position: "bottom", expanded: true },
      ],
      itemSelectorSettings: {
        preselectedItemsFilter: (item, i) => i === 2,
      },
      contentLockEnabled: false, // true
    },
  ],
}

export function useDonationEncourager() {
  const langId = useContext(LangContext).id
  useEffect(() => {
    donEnc("init", DON_ENC_SETTINGS)
    checkPaypal()
    function checkPaypal() {
      const str = window.location.search || ""
      if (str.match("utm-source=paypal-donation")) {
        donEnc("donation")
        const newUrl = window.location.href.split("?")[0]
        window.history.pushState({ path: newUrl }, "", newUrl)
      }
    }
  }, [])

  useEffect(() => {
    if (langId === "de") donEnc("enable")
    else donEnc("disable")
  }, [langId])
}

export function useDonEncPageView(selected, categoryKey = "special") {
  const prevSelected = usePrevious(selected)
  useEffect(() => {
    if (!selected || prevSelected === selected) return
    donEnc("pageview", categoryKey)
    // console.log("PAGE VIEW")
  }, [selected, prevSelected, categoryKey])
}

export function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    if (!value) return
    ref.current = value
  }, [value])
  return ref.current
}
